(() => {
  'use strict';

  const STYLE_ID = 'ww-astra-hotfix-style-v4';
  const LOGO_URL = 'https://cdn.shopify.com/s/files/1/0944/8351/3675/files/WizzyWand.png?v=1788868296';
  let ajaxCartInstalled = false;
  let resizeTimer = null;

  const isEnglish = () => (document.documentElement.lang || '').toLowerCase().startsWith('en');
  const tr = (es, en) => isEnglish() ? en : es;

  const css = `
:root{--wwa-ink:#211e19;--wwa-paper:#f7f4ed;--wwa-gold:#d9b370;--wwa-dark:#171613;--wwa-line:rgba(33,30,25,.14)}
html,body{max-width:100%;overflow-x:clip}
.header-wrapper{background:var(--wwa-paper)!important;color:var(--wwa-ink)!important}
.header__heading,.header__heading-link{overflow:visible!important;opacity:1!important;visibility:visible!important}
.header__heading-link{display:inline-flex!important;align-items:center!important;justify-content:center!important;text-decoration:none!important;color:var(--wwa-ink)!important;min-height:44px!important}
.header__heading-link .h2{display:inline-flex!important;align-items:center!important;justify-content:center!important;margin:0!important;color:var(--wwa-ink)!important;opacity:1!important;visibility:visible!important;line-height:1!important}
.ww-astra-logo-fallback{display:block!important;width:76px!important;height:76px!important;max-width:none!important;object-fit:contain!important;opacity:1!important;visibility:visible!important}
.ww-astra-wordmark{display:inline-flex!important;align-items:center!important;gap:.38rem!important;color:var(--wwa-ink)!important;font-weight:700!important;letter-spacing:-.045em!important;white-space:nowrap!important}
.ww-astra-wordmark__spark{color:#b08c4a!important;font-size:.72em;line-height:1}
.header__heading-logo{display:block!important;opacity:1!important;visibility:visible!important;object-fit:contain!important;max-height:64px!important;width:auto!important}.header__icon,.header__menu-item{color:var(--wwa-ink)!important}.header__icon{min-width:44px;min-height:44px}
[data-wwpdp],[data-ww117]{isolation:isolate}[data-wwpdp] :is(h1,h2,h3,h4,h5,h6,strong,b,label,summary,legend),[data-ww117] :is(h1,h2,h3,h4,h5,h6,strong,b,label,summary,legend){color:var(--ink,var(--ww-ink,#f7f2e9))!important}[data-wwpdp] .rte,[data-wwpdp] .rte *,[data-ww117] .rte,[data-ww117] .rte *{color:#ded8cc!important;background:transparent!important;font-family:inherit!important}[data-wwpdp] .rte :is(h1,h2,h3,h4,h5,h6,strong,b),[data-ww117] .rte :is(h1,h2,h3,h4,h5,h6,strong,b){color:#f7f2e9!important}[data-wwpdp] a,[data-ww117] a{overflow-wrap:anywhere}[data-wwpdp] img,[data-ww117] img{max-width:100%;height:auto}[data-wwpdp] .wwpdp-atc{min-height:54px!important;font-weight:850!important;touch-action:manipulation}
.wa-home .wa-hero :is(h1,h2,h3,strong),.wa-home .wa-story :is(h1,h2,h3,strong),.wa-home .wa-dark :is(h1,h2,h3,strong){color:#f7f2e9!important}.wa-home .wa-hero p,.wa-home .wa-story p,.wa-home .wa-dark p{color:#d8d1c5!important}
cart-drawer.drawer{z-index:4000!important}cart-drawer .cart-drawer{width:min(92vw,430px)!important;max-width:none!important;height:100dvh!important;min-height:100dvh!important;background:var(--wwa-paper)!important;color:var(--wwa-ink)!important;box-shadow:-22px 0 60px rgba(0,0,0,.25)!important}cart-drawer .drawer__inner--wrapper,cart-drawer .drawer__inner,cart-drawer .drawer__inner-empty{background:var(--wwa-paper)!important;color:var(--wwa-ink)!important}cart-drawer .drawer__inner--wrapper{height:100dvh!important;max-height:100dvh!important;display:flex!important;flex-direction:column!important}cart-drawer .drawer__inner{min-height:0!important;overflow-y:auto!important;overscroll-behavior:contain;-webkit-overflow-scrolling:touch}
cart-drawer .custom-header{background:var(--wwa-dark)!important;color:#fff!important;transform:none!important;flex:0 0 auto!important;border:0!important}cart-drawer .custom-header h2{color:#fff!important;font-size:20px!important;line-height:1.2!important;font-weight:800!important;letter-spacing:-.02em!important;padding:15px 54px 15px 18px!important;margin:0!important}cart-drawer .custom-header .drawer__close{width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;top:4px!important;right:8px!important;color:#fff!important}
cart-drawer .drawer__footer{background:var(--wwa-paper)!important;color:var(--wwa-ink)!important;transform:none!important;flex:0 0 auto!important;border-top:1px solid var(--wwa-line)!important;padding:14px 16px max(14px,env(safe-area-inset-bottom))!important;box-shadow:0 -10px 28px rgba(33,30,25,.08)!important}cart-drawer .drawer__footer .cart-drawer__footer{padding:0!important;border:0!important;box-shadow:none!important;background:transparent!important}cart-drawer :is(.cart-item__name,.cart-item__details,.cart-item__price-wrapper,.price,.totals,.totals__total,.totals__total-value,.tax-note,.cart__ctas){color:var(--wwa-ink)!important}cart-drawer .cart-item__name{font-weight:750!important;line-height:1.25!important}cart-drawer .cart-item{border-bottom:1px solid rgba(33,30,25,.08)}cart-drawer .quantity{min-height:42px}cart-drawer input,cart-drawer select{color:var(--wwa-ink)!important;background:#fff!important;border-color:rgba(33,30,25,.18)!important}cart-drawer #CartDrawer-Checkout,cart-drawer .cart__checkout-button{min-height:52px!important;width:100%!important;background:var(--wwa-dark)!important;color:#fff!important;border:0!important;border-radius:12px!important;font-weight:850!important;letter-spacing:.01em!important;box-shadow:none!important}cart-drawer .drawer__overlay{background:rgba(12,11,10,.55)!important;backdrop-filter:blur(2px)}cart-drawer .cart-drawer__empty-content{padding:28px 18px!important;text-align:center}cart-drawer .cart-drawer__empty-content :is(h2,p){color:var(--wwa-ink)!important}
.ww-discovery{margin:clamp(34px,6vw,72px) auto!important;padding:clamp(24px,4vw,40px)!important;border-radius:22px!important;background:#211e19!important;color:#f7f2e9!important;max-width:1200px}.ww-discovery h2{color:#f7f2e9!important;margin-top:0!important}.ww-discovery p{color:#d8d1c5!important}.ww-discovery nav{display:grid!important;grid-template-columns:repeat(5,minmax(0,1fr));gap:10px!important}.ww-discovery a{display:flex!important;align-items:center!important;justify-content:center!important;min-height:48px!important;padding:11px 12px!important;border:1px solid rgba(217,179,112,.35)!important;border-radius:12px!important;color:#f7f2e9!important;background:rgba(255,255,255,.035)!important;text-decoration:none!important;text-align:center!important;font-weight:750!important;line-height:1.25!important}.ww-atc-loading{opacity:.7!important;pointer-events:none!important}.ww-atc-error{margin-top:10px;padding:10px 12px;border-radius:10px;background:#fff1f0;color:#8a1f17;font-size:14px;line-height:1.4}
@media(min-width:750px) and (max-width:989px){.header{padding-top:8px!important;padding-bottom:8px!important}.header__heading-logo{max-height:54px!important}.ww-astra-logo-fallback{width:64px!important;height:64px!important}.ww-discovery nav{grid-template-columns:repeat(3,minmax(0,1fr))!important}}
@media(max-width:749px){.header{padding-left:10px!important;padding-right:10px!important;padding-top:7px!important;padding-bottom:7px!important}.ww-astra-logo-fallback{width:58px!important;height:58px!important}.header__heading-logo{max-width:min(46vw,190px)!important;max-height:50px!important}.header__icons{gap:0!important}[data-wwpdp] .wwpdp-wrap{padding-left:14px!important;padding-right:14px!important}[data-wwpdp] .wwpdp-title,[data-ww117] h1{font-size:clamp(29px,9vw,38px)!important;line-height:1.06!important}[data-wwpdp] :is(input,select,textarea),[data-ww117] :is(input,select,textarea),cart-drawer :is(input,select,textarea){font-size:16px!important}[data-wwpdp] .wwpdp-buybox{padding:16px!important;border-radius:16px!important}[data-wwpdp] .wwpdp-atc{width:100%!important;min-height:56px!important;font-size:16px!important;border-radius:12px!important}cart-drawer .cart-drawer{width:min(94vw,410px)!important}.ww-discovery{margin:30px 12px!important;padding:22px 14px!important;border-radius:18px!important}.ww-discovery nav{grid-template-columns:1fr!important}.ww-discovery a{justify-content:flex-start!important;padding-left:16px!important}}
@media(max-width:380px){.ww-astra-logo-fallback{width:52px!important;height:52px!important}cart-drawer .cart-drawer{width:96vw!important}}`;

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function markPage() {
    const isFireWand = location.pathname.includes('/products/fire-breathing-magic-wand-toy');
    document.documentElement.classList.toggle('ww-firewand-page', isFireWand);
  }

  function fallbackWordmark(el) {
    el.textContent = '';
    el.classList.add('ww-astra-wordmark');
    const spark = document.createElement('span');
    spark.className = 'ww-astra-wordmark__spark';
    spark.setAttribute('aria-hidden', 'true');
    spark.textContent = '✦';
    const name = document.createElement('span');
    name.textContent = 'WizzyWand';
    el.append(spark, name);
  }

  function enhanceBrand() {
    document.querySelectorAll('.header__heading-link .h2').forEach((el) => {
      if (el.querySelector('.ww-astra-logo-fallback') || el.classList.contains('ww-astra-wordmark')) return;
      const img = document.createElement('img');
      img.className = 'ww-astra-logo-fallback';
      img.src = LOGO_URL;
      img.alt = 'WizzyWand';
      img.width = 76;
      img.height = 76;
      img.addEventListener('error', () => fallbackWordmark(el), { once: true });
      el.textContent = '';
      el.appendChild(img);
    });
  }

  function localizeDrawer() {
    const cartTitle = tr('Tu carrito', 'Your cart');
    const discount = tr('Código de descuento', 'Discount code');
    const add = tr('Añadir', 'Add');
    const save = tr('Ahorras', 'Save');

    document.querySelectorAll('cart-drawer .custom-header h2').forEach((el) => {
      const current = (el.textContent || '').trim();
      if ((!current || /^(cart:?|tu carrito|your cart)$/i.test(current)) && current !== cartTitle) el.textContent = cartTitle;
    });
    document.querySelectorAll('cart-drawer input[name="cart-discount-field"]').forEach((el) => {
      if (el.placeholder !== discount) el.placeholder = discount;
      if (el.getAttribute('aria-label') !== discount) el.setAttribute('aria-label', discount);
    });
    document.querySelectorAll('cart-drawer label').forEach((el) => {
      const current = (el.textContent || '').trim();
      if (/^(discount code|código de descuento)$/i.test(current) && current !== discount) el.textContent = discount;
    });
    document.querySelectorAll('cart-drawer button,cart-drawer a').forEach((el) => {
      const current = (el.textContent || '').trim();
      if (/^(add|añadir)$/i.test(current) && current !== add) el.textContent = add;
    });
    document.querySelectorAll('cart-drawer .totals__total-value strong,cart-drawer .cart-item__savings').forEach((el) => {
      const text = el.textContent || '';
      if (isEnglish()) {
        if (/\bAhorras\b/i.test(text)) el.textContent = text.replace(/\bAhorras\b/gi, save);
      } else if (/\bSave\b/i.test(text)) {
        el.textContent = text.replace(/\bSave\b/gi, save);
      }
    });
  }

  function localizedPath(path) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function ensureDiscovery() {
    if (!/\/products\//.test(location.pathname) || document.querySelector('.ww-discovery')) return;
    const main = document.getElementById('MainContent');
    if (!main) return;
    const labels = isEnglish()
      ? ['Wands & magic', 'Games & puzzles', 'Collectibles', 'Style & accessories', 'Decor & gifts']
      : ['Varitas y magia', 'Juegos y puzzles', 'Coleccionables', 'Moda y accesorios', 'Decoración y regalos'];
    const paths = ['/collections/varitas-y-magia', '/collections/juegos-y-puzzles', '/collections/coleccionables-y-figuras', '/collections/moda-y-accesorios', '/collections/decoracion-y-regalos'];
    const section = document.createElement('section');
    section.className = 'ww-discovery ww-discovery--runtime page-width';
    section.setAttribute('aria-label', tr('Descubre más en WizzyWand', 'Discover more at WizzyWand'));
    const links = paths.map((path, i) => `<a href="${localizedPath(path)}">${labels[i]} →</a>`).join('');
    section.innerHTML = `<div><h2>${tr('Descubre más magia', 'Discover more magic')}</h2><p>${tr('Explora otras colecciones de WizzyWand y encuentra tu próxima pieza.', 'Explore more WizzyWand collections and find your next piece.')}</p><nav aria-label="${tr('Colecciones WizzyWand', 'WizzyWand collections')}">${links}</nav></div>`;
    main.appendChild(section);
  }

  function showError(form, message) {
    const old = form.querySelector('.ww-atc-error');
    if (old) old.remove();
    const box = document.createElement('div');
    box.className = 'ww-atc-error';
    box.setAttribute('role', 'alert');
    box.textContent = message || tr('No hemos podido añadir el producto. Inténtalo de nuevo.', 'We could not add the product. Please try again.');
    form.appendChild(box);
  }

  function patchCartDrawer() {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('cart-drawer').then(() => {
      const Ctor = customElements.get('cart-drawer');
      const proto = Ctor && Ctor.prototype;
      if (!proto || proto.__wwCartPatched) return;
      const original = proto.getSectionsToRender;
      proto.getSectionsToRender = function () {
        const result = typeof original === 'function' ? original.call(this) : [];
        const sections = Array.isArray(result) ? result.slice() : [];
        if (!sections.some((section) => section && section.id === 'cart-icon-bubble')) sections.push({ id: 'cart-icon-bubble' });
        return sections;
      };
      proto.__wwCartPatched = true;
    }).catch(() => {});
  }

  function watchDrawer(drawer) {
    if (!drawer || drawer.dataset.wwLocalizationReady === 'true') return;
    drawer.dataset.wwLocalizationReady = 'true';
    localizeDrawer();
    new MutationObserver(() => localizeDrawer()).observe(drawer, { childList: true, subtree: true });
  }

  function installAjaxCart() {
    if (ajaxCartInstalled) return;
    ajaxCartInstalled = true;
    watchDrawer(document.querySelector('cart-drawer'));
    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute('action') || '';
      if (!action.includes('/cart/add')) return;
      if (form.closest('product-form') || form.closest('cart-drawer')) return;
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      const button = event.submitter || form.querySelector('[type="submit"]');
      if (button && (button.name === 'checkout' || button.closest('.shopify-payment-button'))) return;
      if (form.dataset.wwAdding === 'true') {
        event.preventDefault();
        return;
      }
      event.preventDefault();
      form.dataset.wwAdding = 'true';
      const oldError = form.querySelector('.ww-atc-error');
      if (oldError) oldError.remove();
      const oldHtml = button ? button.innerHTML : '';
      if (button) {
        button.disabled = true;
        button.classList.add('ww-atc-loading');
        button.setAttribute('aria-busy', 'true');
      }
      try {
        const formData = new FormData(form);
        if (!formData.get('id')) throw new Error(tr('Selecciona una opción disponible.', 'Select an available option.'));
        const renderList = typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender() : [];
        const ids = [...new Set(renderList.map((section) => section && section.id).filter(Boolean).concat('cart-icon-bubble'))];
        formData.set('sections', ids.join(','));
        formData.set('sections_url', location.pathname);
        const url = (window.routes && window.routes.cart_add_url) || form.action || '/cart/add';
        const response = await fetch(url, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || tr('No hemos podido añadir el producto.', 'We could not add the product.'));
        if (data.sections && typeof drawer.renderContents === 'function') {
          if (typeof drawer.setActiveElement === 'function' && button) drawer.setActiveElement(button);
          drawer.renderContents(data);
        } else if (typeof drawer.open === 'function') {
          drawer.open(button);
        }
        setTimeout(localizeDrawer, 0);
        document.dispatchEvent(new CustomEvent('wizzy:cart-added', { detail: data }));
      } catch (error) {
        showError(form, error && error.message ? error.message : null);
      } finally {
        form.dataset.wwAdding = 'false';
        if (button) {
          button.disabled = false;
          button.classList.remove('ww-atc-loading');
          button.removeAttribute('aria-busy');
          if (oldHtml) button.innerHTML = oldHtml;
        }
      }
    }, true);
  }

  function stabilizeSliders() {
    const sliders = document.querySelectorAll('.image-video-slider');
    if (!sliders.length) return;
    if (!window.jQuery || !window.jQuery.fn || typeof window.jQuery.fn.slick !== 'function') {
      sliders.forEach((el) => { el.style.visibility = 'visible'; });
      return;
    }
    window.jQuery('.image-video-slider').each(function () {
      const el = this;
      const $el = window.jQuery(el);
      if (!$el.hasClass('slick-initialized')) {
        el.style.visibility = 'visible';
        return;
      }
      if (window.innerWidth >= 750) {
        const desktop = Number($el.data('slides-to-show')) || 3;
        const target = window.innerWidth < 990 ? Math.min(2, desktop) : desktop;
        const current = Number($el.slick('slickGetOption', 'slidesToShow'));
        if (current !== target) $el.slick('slickSetOption', 'slidesToShow', target, true);
      }
      el.style.visibility = 'visible';
    });
  }

  function boot() {
    injectStyles();
    markPage();
    enhanceBrand();
    localizeDrawer();
    ensureDiscovery();
    patchCartDrawer();
    installAjaxCart();
    stabilizeSliders();
    setTimeout(stabilizeSliders, 900);
    setTimeout(stabilizeSliders, 2200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(stabilizeSliders, 180);
  }, { passive: true });

  document.addEventListener('shopify:section:load', () => {
    markPage();
    enhanceBrand();
    localizeDrawer();
    ensureDiscovery();
    watchDrawer(document.querySelector('cart-drawer'));
    setTimeout(stabilizeSliders, 50);
  });
})();